/**
 * Client-side stable sort for relationship columns that can't be ordered by the
 * server query — a joined name (District on the Schools page) or a child count
 * (Schools on the Districts page). Numbers sort numerically; everything else
 * sorts case-insensitively. Does not mutate the input.
 */
export function sortRows<T>(
    rows: T[],
    order: 'asc' | 'desc',
    value: (row: T) => string | number,
): T[] {
    const dir = order === 'asc' ? 1 : -1;
    return [...rows].sort((a, b) => {
        const av = value(a);
        const bv = value(b);
        if (typeof av === 'number' && typeof bv === 'number') return (av - bv) * dir;
        return String(av).toLowerCase().localeCompare(String(bv).toLowerCase()) * dir;
    });
}
